module.exports = __webpack_public_path__ + "static/img/USC_Marshall_CurriculumMap_2023_REFD_R2.5232c03.png";


//////////////////
// WEBPACK FOOTER
// ./static/USC_Marshall_CurriculumMap_2023_REFD_R2.png
// module id = goj5
// module chunks = 1